export default __webpack_public_path__ + "static/media/comingsoon.1be4f331.png";